<template>
    <v-dialog :value="value" @input="$emit('input', $event)" :persistent="progress" max-width="650">
        <v-card>
            <v-card-title>{{ title }}</v-card-title>
            <v-form @submit.prevent="$emit('save', draft.trim())" autocomplete="off">
                <v-card-text>
                    <v-alert v-if="error" type="error" text dense>{{ error }}</v-alert>
                    <v-text-field
                        v-model="draft"
                        :error-messages="nameErrors"
                        :disabled="progress"
                        label="Название поиска"
                        name="saved-search-name"
                        maxlength="150"
                        autofocus
                    />
                    <div class="font-weight-medium mb-2">Выбранные фильтры</div>
                    <search-filter-summary :items="summary" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn @click="$emit('input', false)" :disabled="progress" text>Отмена</v-btn>
                    <v-btn type="submit" :loading="progress" :disabled="!draft.trim()" color="primary">Сохранить</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import SearchFilterSummary from './SearchFilterSummary.vue'

export default {
    name: 'SavedSearchDialog',
    components: {SearchFilterSummary},
    props: {
        value: Boolean,
        title: {type: String, default: 'Сохранить поиск в избранное'},
        name: {type: String, default: ''},
        summary: {type: Array, default: () => []},
        progress: Boolean,
        error: {type: String, default: ''},
        nameErrors: {type: Array, default: () => []},
    },
    data () { return {draft: ''} },
    watch: {
        value (visible) { if (visible) this.draft = this.name },
    },
}
</script>
